import React from "react";
import "./SoftwareSkill.scss";
import { skillsSection } from "../../portfolio";
import { SiAdobeillustrator, SiAdobephotoshop, SiExpress, SiFastapi, SiMaterialui, SiMongodb, SiMysql, SiTailwindcss, SiRedux } from 'react-icons/si';

export default function SoftwareSkill() {
  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons">
          {skillsSection.softwareSkills.map((skill, i) => {
            return (
              <li
                key={i}
                className="software-skill-inline"
                name={skill.skillName}
                style={{ color: skill.color }}
              >
                <i className={skill.fontAwesomeClassname}></i>
                {
                  skill.fontAwesomeClassname === 'redux' && <i><SiRedux className="external-icon" /></i>
                }

                {
                  skill.fontAwesomeClassname === 'mui' && <i><SiMaterialui className="external-icon" /></i>
                }
                {
                  skill.fontAwesomeClassname === 'tailwind' && <i><SiTailwindcss className="external-icon" /></i>
                }
                {
                  skill.fontAwesomeClassname === 'api' && <i><SiFastapi className="external-icon" /></i>
                }
                {
                  skill.fontAwesomeClassname === 'express' && <i><SiExpress className="external-icon" /></i>
                }
                {
                  skill.fontAwesomeClassname === 'mongo' && <i><SiMongodb className="external-icon" /></i>
                }
                {
                  skill.fontAwesomeClassname === 'mysql' && <i><SiMysql className="external-icon" /></i>
                }
                {
                  skill.fontAwesomeClassname === 'ai' && <i><SiAdobeillustrator className="external-icon" /></i>
                }
                {
                  skill.fontAwesomeClassname === 'photoshop' && <i><SiAdobephotoshop className="external-icon" /></i>
                }
                <p style={{ color: skill.color }}>{skill.skillName}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
